const collectionId = 'liberty';
const milleage = 'Liberty';

module.exports = [
  {
    id: 'silver-50',
    label: '<b>50 silver coin</b>',
    value: 50,
    sellPrice: 55,
    state: 2,
    price: '50,00 €',
    collection: collectionId,
    wave: 3,
    specs: [
      { label: 'Edition year', value: milleage },
      { label: 'Metal', value: 'Silver 900‰' },
      { label: 'Weight', value: '16 g' },
      { label: 'Diameter', value: 'Ø 33' },
      { label: 'Copies', value: '75 000' },
    ],
    // subscription: {
    //   startDate: '2026-05-05',
    //   endDate: '2026-06-04',
    // },
  },
  {
    id: 'silver-100',
    label: '<b>100 silver coin</b>',
    value: 100,
    sellPrice: 115,
    state: 3,
    price: '100,00 €',
    collection: collectionId,
    wave: 1,
    specs: [
      { label: 'Edition year', value: milleage },
      { label: 'Metal', value: 'Silver 900‰' },
      { label: 'Weight', value: '45 g' },
      { label: 'Diameter', value: 'Ø 47' },
      { label: 'Copies', value: '10 000' },
    ],
  },
  {
    id: 'gold-250',
    label: '<b>250 gold coin</b>',
    value: 250,
    sellPrice: 285,
    state: 1,
    price: '250,00 €',
    collection: collectionId,
    wave: 1,
    specs: [
      { label: 'Edition year', value: milleage },
      { label: 'Metal', value: 'Gold 999‰' },
      { label: 'Quality', value: 'Uncirculated quality' },
      { label: 'Weight', value: '1,75 g' },
      { label: 'Diameter', value: 'Ø 13' },
      { label: 'Copies', value: '15 000' },
    ],
  },
  {
    id: 'gold-1000',
    label: '<b>1 000 gold coin</b>',
    value: 1000,
    sellPrice: 1090,
    state: 3,
    price: '1000,00 €',
    collection: collectionId,
    wave: 2,
    subscription: {
      startDate: '2026-03-10',
      endDate: '2026-04-09',
      legals: "Jusqu'au 27 mars, achetez cette monnaie à sa valeur faciale",
    },
    specs: [
      { label: 'Edition year', value: milleage },
      { label: 'Metal', value: 'Gold 999‰' },
      { label: 'Quality', value: 'Uncirculated quality' },
      { label: 'Weight', value: '6,5 g' },
      { label: 'Diameter', value: 'Ø 23' },
      { label: 'Copies', value: '6 000' },
    ],
  },
  {
    id: 'gold-2500',
    label: '<b>2 500 gold coin</b>',
    value: 2500,
    sellPrice: 2750,
    state: 0,
    price: '2500,00 €',
    collection: collectionId,
    wave: 3,
    subscription: {
      startDate: '2026-05-05',
      endDate: '2026-06-04',
    },
    specs: [
      { label: 'Edition year', value: milleage },
      { label: 'Metal', value: 'Gold 999‰' },
      { label: 'Quality', value: 'Uncirculated quality' },
      { label: 'Weight', value: '16,25 g' },
      { label: 'Diameter', value: 'Ø 33' },
      { label: 'Copies', value: '2 000' },
    ],
  },
  {
    id: 'gold-5000',
    label: '<b>5 000 gold coin</b>',
    value: 5000,
    sellPrice: 5250,
    state: 0,
    price: '5000,00 €',
    collection: collectionId,
    wave: 4,
    // subscription: {
    //   startDate: '2026-09-08',
    //   endDate: '2026-10-08',
    // },
    specs: [
      { label: 'Edition year', value: milleage },
      { label: 'Metal', value: 'Gold 999‰' },
      { label: 'Quality', value: 'Uncirculated quality' },
      { label: 'Weight', value: '26 g' },
      { label: 'Diameter', value: 'Ø 37' },
      { label: 'Copies', value: '1 200' },
    ],
  },
  {
    id: 'gold-10000',
    label: '<b>10 000 gold coin</b>',
    value: 10000,
    sellPrice: 10500,
    state: 0,
    price: '10000,00 €',
    collection: collectionId,
    wave: 5,
    specs: [
      { label: 'Edition year', value: milleage },
      { label: 'Metal', value: 'Gold 999‰' },
      { label: 'Quality', value: 'Uncirculated quality' },
      { label: 'Weight', value: '50 g' },
      { label: 'Diameter', value: 'Ø 45' },
      { label: 'Copies', value: '200' },
    ],
    // subscription: {
    //   startDate: '2026-12-02',
    //   endDate: '2027-01-01',
    // },
  },
];
